import { defineMessages } from "react-intl";

const scope = "supportui.component.FuelingProcessDetail";

export default defineMessages({
  detailsTitle: {
    id: `${scope}.detailsTitle`,
    defaultMessage: "Fueling process information",
  },
  setReceipt: {
    id: `${scope}.setReceipt`,
    defaultMessage: "Set receipt",
  },
  cancelProcess: {
    id: `${scope}.cancelProcess`,
    defaultMessage: "Cancel process",
  },
});
